/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SettingsCondition
 */
export interface SettingsCondition {
    /**
     * 
     * @type {string}
     * @memberof SettingsCondition
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingsCondition
     */
    conditionType?: SettingsConditionConditionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SettingsCondition
     */
    filterType?: SettingsConditionFilterTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SettingsCondition
     */
    matchType?: SettingsConditionMatchTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SettingsCondition
     */
    matchValue?: string;
}


/**
 * @export
 */
export const SettingsConditionConditionTypeEnum = {
    Url: 'URL',
    Geo: 'GEO',
    Chat: 'CHAT'
} as const;
export type SettingsConditionConditionTypeEnum = typeof SettingsConditionConditionTypeEnum[keyof typeof SettingsConditionConditionTypeEnum];

/**
 * @export
 */
export const SettingsConditionFilterTypeEnum = {
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE'
} as const;
export type SettingsConditionFilterTypeEnum = typeof SettingsConditionFilterTypeEnum[keyof typeof SettingsConditionFilterTypeEnum];

/**
 * @export
 */
export const SettingsConditionMatchTypeEnum = {
    Simple: 'SIMPLE',
    Exact: 'EXACT',
    Regex: 'REGEX',
    Substring: 'SUBSTRING',
    CountryCode: 'COUNTRY_CODE',
    AgentsAvailable: 'AGENTS_AVAILABLE'
} as const;
export type SettingsConditionMatchTypeEnum = typeof SettingsConditionMatchTypeEnum[keyof typeof SettingsConditionMatchTypeEnum];


/**
 * Check if a given object implements the SettingsCondition interface.
 */
export function instanceOfSettingsCondition(value: object): value is SettingsCondition {
    return true;
}

export function SettingsConditionFromJSON(json: any): SettingsCondition {
    return SettingsConditionFromJSONTyped(json, false);
}

export function SettingsConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SettingsCondition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'conditionType': json['conditionType'] == null ? undefined : json['conditionType'],
        'filterType': json['filterType'] == null ? undefined : json['filterType'],
        'matchType': json['matchType'] == null ? undefined : json['matchType'],
        'matchValue': json['matchValue'] == null ? undefined : json['matchValue'],
    };
}

export function SettingsConditionToJSON(json: any): SettingsCondition {
    return SettingsConditionToJSONTyped(json, false);
}

export function SettingsConditionToJSONTyped(value?: SettingsCondition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'conditionType': value['conditionType'],
        'filterType': value['filterType'],
        'matchType': value['matchType'],
        'matchValue': value['matchValue'],
    };
}

